import Swiper from 'swiper';
import {
  Autoplay,
  Keyboard,
  Navigation,
  Pagination,
  EffectFade,
  FreeMode,
} from 'swiper/modules';

// import doModal from './modal';

function convertRemToPixels(remValue) {
  // Get the computed font size of the root HTML element
  const rootFontSize = parseFloat(
    getComputedStyle(document.documentElement).fontSize,
  );

  // Calculate the pixel value
  const pixelValue = remValue * rootFontSize;

  return pixelValue;
}

const doGallery = (swiper) => {
  const parameters = {
    modules: [Autoplay, Keyboard, Navigation, Pagination, EffectFade, FreeMode],
    pagination: false,
    navigation: false,
    autoplay: false,
    allowTouchMove: false,
    loop: false,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    init: false,
  };

  const next = swiper.parentElement.querySelector('.swiper-button-next-1');
  const prev = swiper.parentElement.querySelector('.swiper-button-prev-1');

  if (next && prev) {
    parameters.navigation = {
      nextEl: next,
      prevEl: prev,
    };
  }

  const pagination = swiper.querySelector('.swiper-pagination');

  if (pagination) {
    parameters.pagination = {
      el: pagination,
      clickable: false,
      type: 'fraction',
    };
  }

  if (swiper.classList.contains('loop')) {
    parameters.loop = true
  }

    if (swiper.classList.contains('no-auto')) {
    parameters.autoplay = false,
    parameters.speed = 666;
  }

  if (swiper.classList.contains('autoplay')) {
    parameters.autoplay = {
      delay: 2500,
      disableOnInteraction: false,
    };
    parameters.speed = 666;
  }

  if (swiper.classList.contains('autoplay10000')) {
    parameters.autoplay = {
      delay: 10000,
      disableOnInteraction: false,
    };
    parameters.speed = 666;
  }

  if (swiper.classList.contains('autoplay5000')) {
    parameters.autoplay = {
      delay: 5000,
      disableOnInteraction: false,
    };
    parameters.speed = 666;
  }

  if (swiper.classList.contains('autoplay-static')) {
    parameters.autoplay = {
      delay: 2500,
      disableOnInteraction: false,
    };
    parameters.speed = 33;
  }

  if (swiper.classList.contains('fade')) {
    parameters.effect = 'fade';
    parameters.fadeEffect = {
      crossFade: true,
    };
    parameters.allowTouchMove = true;
    parameters.simulateTouch = true;
  }


  
    if (swiper.classList.contains('carousel')) {

      // Carousel defaults: touch + cursor affordance for horizontal lists.
      parameters.allowTouchMove = true;
      parameters.simulateTouch = true;
      parameters.grabCursor = true;
      // Mobile-first: freeMode on <=768, disabled at >=769.
      parameters.freeMode = {
        enabled: true,
        sticky: false,
      };
      parameters.slidesOffsetBefore = convertRemToPixels(1);
      parameters.breakpoints = {
        769: {
          freeMode: {
            enabled: false,
          },
          slidesOffsetBefore: 0,
        },
      };

      // For carousels with autoplay, stop autoplay after any interaction.
      if (parameters.autoplay && typeof parameters.autoplay === 'object') {
        parameters.autoplay.disableOnInteraction = true;
      }

      // Only loop when there are more slides than the visible count.
      const totalSlides = swiper.querySelectorAll('.swiper-slide').length;
      const slidesPerView = swiper.parentElement.getAttribute('data-slides-per-view');
      const parsedSlidesPerView = slidesPerView ? parseFloat(slidesPerView) : 2;
      const maxSlidesPerView = Number.isFinite(parsedSlidesPerView) ? parsedSlidesPerView : 2;
      parameters.loop = totalSlides > maxSlidesPerView;

      if (slidesPerView) {

        // Align base/mobile view with 2-up layout, then expand at md+.
        parameters.spaceBetween = convertRemToPixels(1);
        parameters.centeredSlides = false;
        parameters.slidesPerView = 1.5;
        // parameters.slidesPerGroup = 1;

        parameters.breakpoints[769] = {
          ...parameters.breakpoints[769],
          slidesPerView: slidesPerView,
        };
      }
    }
    if( swiper.classList.contains('image-sequence-gallery')) {
    const autoplay = swiper.dataset.autoplay ? parseInt(swiper.dataset.autoplay, 10) : 500;

    parameters.autoplay = {
      delay: autoplay,
      disableOnInteraction: true,
      waitForTransition: false,
    };

    parameters.loop = true;

    // work out the speed, if its faster than 2000ms, use fade effect
    const speed = swiper.dataset.speed
      ? parseInt(swiper.dataset.speed, 10)
      : autoplay;
    const fadeDuration = 300;
    const fastFadeDuration = 0; // instant crossfade for fast sequences

    parameters.effect = 'fade';
    parameters.fadeEffect = {
      crossFade: true,
    };
    parameters.speed = speed > 2000 ? fadeDuration : fastFadeDuration;
    
    parameters.allowTouchMove = false;
    parameters.simulateTouch = false;
    parameters.keyboard = false;

  }

  const newSwiper = new Swiper(swiper, parameters);

  newSwiper.init();
};

export default doGallery;
